export const version = 'kunde-v1.20.0-SNAPSHOT-20e9a1b50611c5662205587cfe5a210421b5bf9f';